const PERMISSION_KEY= "core:authz_subject";
const PAGE_URL = {
    AUTHZ_SUBJECT_PAGE: "/admin/core/authz-subject"
}

export {PERMISSION_KEY, PAGE_URL}

